import React, { createContext, useContext, useState } from 'react';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [isAppLoading, setIsAppLoading] = useState(true);
  const [isHomePageLoading, setIsHomePageLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('Loading...');

  const setAppLoading = (loading, message = 'Loading...') => {
    setIsAppLoading(loading);
    setLoadingMessage(message);
  };

  const setHomePageLoading = (loading) => {
    setIsHomePageLoading(loading);
  };

  // Listen for custom events from class components
  React.useEffect(() => {
    const handleSetAppLoading = (event) => {
      const { loading, message } = event.detail;
      setAppLoading(loading, message);
    };

    window.addEventListener('setAppLoading', handleSetAppLoading);
    
    return () => {
      window.removeEventListener('setAppLoading', handleSetAppLoading);
    };
  }, []);

  const value = {
    isAppLoading,
    isHomePageLoading,
    loadingMessage,
    setAppLoading,
    setHomePageLoading,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};
